import { useApi } from './useApi';

export function usePayments() {
  const { fetchData, postData, putData, patchData } = useApi();
  const fetchPaymentsApi = async (params = {}) => {
    try {
      const result = await fetchData('/api/payments', { params });
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: err.message || 'Lỗi kết nối' };
    }
  };

  const deletePaymentsApi = async (id) => {
    try {
      return { success: true };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  const getPaymentsDetailApi = async (id) => {
      try {
          const result = await fetchData(`/api/payments/${id}?include=items,customer&searchJoin=AND`);
          return { success: true, data: result };
      } catch (err) {
          return { success: false, error: err.message || 'Lỗi kết nối' };
      }
  };

  const createPaymentsApi = async (credentials) => {
    try {
      const result = await postData('/api/payments', credentials);
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  const updatePaymentsApi = async (id, credentials) => {
      try {
          const result = await putData(`/api/payments/${id}`, credentials);
          return { success: true, data: result };
      } catch (err) {
          return { success: false, error: err.message || 'Lỗi kết nối' };
      }
  };

  const payOrdersApi = async (payload) => {
    try {
      const idempotencyKey = crypto.randomUUID();
      const result = await postData('/api/payments/pay/orders', payload, {
        headers: { 'Idempotency-Key': idempotencyKey },
      });
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: err.message || 'Lỗi thanh toán' };
    }
  };

  const patchPaymentApi = async (id, status) => {
    try {
      const result = await patchData(`/api/payments/${id}`, { status });
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: err?.response?.data?.message || err.message || 'Thao tác thất bại' };
    }
  };

  const bulkPatchPaymentsApi = async (ids, status) => {
    try {
      const result = await patchData('/api/payments', { ids, status });
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: err?.response?.data?.message || err.message || 'Thao tác hàng loạt thất bại' };
    }
  };

  const getQrInfoApi = async (id) => {
    try {
      const result = await fetchData(`/api/payments/${id}/qr-info`);
      return { success: true, data: result };
    } catch (err) {
      return { success: false, error: err?.response?.data?.message || err.message || 'Không lấy được thông tin QR' };
    }
  };

  const exportPaymentsApi = (params = {}) => {
    const queryParams = {
      ...params,
      ids: Array.isArray(params.ids) ? params.ids.join(',') : params.ids,
    };

    return fetchData('/api/payments/export', { params: queryParams, responseType: 'blob' });
  };

  return {
    fetchPaymentsApi,
    deletePaymentsApi,
    createPaymentsApi,
    getPaymentsDetailApi,
    updatePaymentsApi,
    payOrdersApi,
    patchPaymentApi,
    bulkPatchPaymentsApi,
    getQrInfoApi,
    exportPaymentsApi,
  };
}
